type ToastWithVariant = {
  variant: string
}

export function appendToast<T extends ToastWithVariant>(
  currentToasts: T[],
  nextToast: T
): T[] {
  const alreadyHasAbandonedToast =
    nextToast.variant === 'abandoned' &&
    currentToasts.some((toast) => toast.variant === 'abandoned')

  if (alreadyHasAbandonedToast) {
    return currentToasts
  }

  return [...currentToasts, nextToast]
}
